import React from 'react';

function VersionBuild() {
  return (
    <p className="text-muted fs-sm">
      {`Version ${process.env.REACT_APP_VERSION} Build ${process.env.REACT_APP_BUILD}`}
    </p>
  );
}

export default VersionBuild;
